import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
  FinancialObligation,
  FinancialObligationList,
  FinancialObligationPayment,
  FinancialSummary,
} from '../models'
import { ApiService } from './api.service'

export interface FinancialObligationQuery {
  page?: number
  per_page?: number
  search_term?: string
  [key: `order[${string}]`]: string
}

@Injectable({
  providedIn: 'root',
})
export class FinancialObligationService {
  constructor(private api: ApiService) {}

  public mine(
    params: FinancialObligationQuery = {},
    options?: any,
  ): Observable<FinancialObligationList> {
    const defaults = { page: 1, per_page: 25 }

    return this.api.findAllAs(
      'sales/mine',
      {
        ...options,
        params: { ...defaults, ...params, list: 'financial_obligations' },
      },
      FinancialObligation,
    ) as Observable<FinancialObligationList>
  }

  public upcomingPayments(
    params: Pick<FinancialObligationQuery, 'per_page'> = {},
    options?: any,
  ): Observable<FinancialSummary[]> {
    return this.api
      .findAllAs(
        'sales/mine',
        {
          ...options,
          params: { per_page: 3, ...params, list: 'upcoming_payments' },
        },
        FinancialObligationPayment,
      )
      .pipe(
        map((payments) =>
          payments.map((payment) => this.toFinancialSummary(payment)),
        ),
      )
  }

  private toFinancialSummary(
    payment: FinancialObligationPayment,
  ): FinancialSummary {
    const state = ['Unpaid']
    if (payment.status === 'past-due' || payment.due_date_days_past > 0) {
      state.push('PastDue')
    }

    let paymentDescription: string
    if (payment.auto_pay) {
      state.push('AutoPay')
      paymentDescription = `${payment.auto_pay.account_type} ending in ${payment.auto_pay.last_four}`
    }

    return new FinancialSummary({
      id: payment.id,
      amount: payment.amount_cents,
      description: payment.description,
      currency: payment.currency,
      dueDate: payment.due_date,
      href: payment.payment_url,
      sourceType: payment.kind,
      state,
      paymentDescription,
    })
  }
}
